export default "__VITE_ASSET__DRGap9t2__"